import { urlLabel } from '../../../enum/PermissionEnum';
import { roleType } from '../../../enum/RequestEnum';
import { getNationalNumber } from '../../../helpers';
import fetchHelper from '../../../helpers/FetchHelper';
import { saveToStorage } from '../../../helpers/StorageHelper';
import { stopConnection as wrSignalRStopConnection } from '../../../helpers/waitingRoomSignalR';
import { signInChatUser, signOutChatUser } from '@/chatAuth';
import { ROLE_TYPES } from '@/constants/roles';
import { stopConnection as appSignalRStopConnection } from '@/helpers/appointmentSignalR';
import { stopConnection as teleCounselSignalRStopConnection } from '@/helpers/telecounsellingRoomSignalR';
import customToast from '@/new-components/CustomNotification';
import globalDispatcher from '@/redux/global/actions';
import { synthesize } from 'redux-dispatcher';

const mapDispatchToAC = {
  addNotifyToken:
    (payload, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        'notifications/token',
        payload,
        {},
        {},
        false
      );
      if (status === 200) {
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    },

  deleteNotifyToken:
    (payload) =>
    async ({ Api }) => {
      await Api.delete('notifications/token', payload);
    },

  loginSuccess: (result, email) => ({ result, email }),

  login:
    (email, password, callback) =>
    async ({ Api }) => {
      const body = {
        email,
        password,
        clientType: 'Web',
      };
      const { result, message, status } = await Api.post(
        `auth/sessions`,
        body,
        undefined,
        undefined,
        false
      );
      if (status === 200) {
        callback(result, email);
      } else {
        if (message === 'User does not exist')
          callback('Wrong username and password', null);
        else callback(message);
      }
    },

  loginWithGoogle:
    (user, token, callback) =>
    async ({ Api }) => {
      const body = {
        token,
        clientType: 'Web',
      };
      const { result, status } = await Api.post(`auth/sessions/google`, body);
      if (status === 200) {
        callback(result);
      }
    },

  logoutSuccess: () => ({}),
  logout:
    () =>
    async ({ Api }) => {
      // localStorage.removeItem('roleName');
      localStorage.removeItem('persist:root');
      fetchHelper.addDefaultHeader('Authorization', ``);
      authDispatcher.logoutSuccess();
      wrSignalRStopConnection();
      appSignalRStopConnection();
      teleCounselSignalRStopConnection();
      signOutChatUser();
    },

  registerSuccess: (generalInfo, rest) => ({ generalInfo, rest }),
  register:
    (
      email,
      password,
      mobile,
      countryCode,
      mcr,
      praticisingCertificate,
      pcExpiry,
      clinicId,
      firstName,
      lastName,
      credentials,
      history
    ) =>
    async ({ Api, customToast }) => {
      const body = {
        email,
        password,
        mobile: getNationalNumber(mobile, countryCode),
        countryCode,
        mcr,
        praticisingCertificate,
        pcExpiry,
        clinicId,
        firstName,
        lastName,
        credentials,
        roleType: roleType.Doctor,
      };
      const { status } = await Api.post('doctors', body);
      if (status === 200) {
        customToast('success', 'Register success. Please waiting for approval');
        history.push(`/${urlLabel.home}`);
      }
    },
  registerInternal:
    (data, history) =>
    async ({ Api }) => {
      const { status } = await Api.post('users/register', {
        ...data,
        roleType: 'Trainer',
      });
      authDispatcher.setState('loading', false);
      if (status === 200) {
        customToast('success', 'Register success. Please waiting for approval');
        history.push(`/${urlLabel.internalLogin}`);
      }
    },
  setState: (state, value) => ({ state, value }),
  getUserInfoSuccess: (roleType, userInfo) => ({ roleType, userInfo }),
  getUserInfo:
    (callback) =>
    async ({ Api }) => {
      authDispatcher.getServerTime();
      const { result, status } = await Api.get(`users/me`);
      if (status === 200) {
        const { roleType, ...rest } = result;
        signInChatUser(
          Api.get('firebase/custom-token').then(({ result }) => result?.token)
        );
        callback && callback(result);
        authDispatcher.getUserInfoSuccess({ roleType }, rest);
        localStorage.setItem('roleName', result.roleName);
        if (result.roleName === ROLE_TYPES.PATIENT) {
          globalDispatcher.getPatientInfo();
        }
      }
    },

  getAllClinicsSuccess: (clinics) => ({ clinics }),
  getAllClinics:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.post('clinics/filter', {});
      if (status === 200) authDispatcher.getAllClinicsSuccess(result);
    },

  sendResetPasswordEmail:
    (email) =>
    async ({ Api }) => {
      const { status } = await Api.post('users/password/forgot', {
        email,
        clientType: 'Web',
      });
      if (status === 200) {
        customToast(
          'success',
          `A reset password email has been sent to ${email}`
        );
      }
    },

  resetPassword:
    (token, userId, password, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post('users/password-resets', {
        token,
        userId,
        password,
      });
      if (status === 200) {
        customToast('success', 'Your password has been changed successfully!');
        callback && callback();
      }
    },

  resetPasswordOldUser:
    (token, password, callback) =>
    async ({ Api }) => {
      const { status } = await Api.put('patients/change-old-user-pw', {
        token,
        password,
      });
      if (status === 200) {
        customToast('success', 'Your password has been changed successfully!');
        callback && callback();
      }
    },

  updateDoctorProfile:
    (data, history) =>
    async ({ Api }) => {
      const { status } = await Api.put(`doctors/me`, data, undefined, {
        Authorization: `Bearer ${data.accessToken}`,
      });
      if (status === 200) {
        customToast(
          'success',
          'Your profile has been updated. Please waiting for approval'
        );
        setTimeout(() => history.push(`/`));
      }
    },
  getServerTime:
    () =>
    async ({ Api }) => {
      const { result, status } = await Api.get(`configurations/server-time`);
      if (status === 200) {
        const serverTime = new Date(result);
        const clientTime = new Date();
        const offset = serverTime - clientTime;
        saveToStorage('serverTimeOffset', offset);
      }
    },
  sendOTP:
    (params, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post('users/send-otp', params);
      if (status === 200) {
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    },
  verifyOTP:
    (params, callback) =>
    async ({ Api }) => {
      const { result } = await Api.put(`users/verify-otp`, params);
      if (result) {
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    },
  getAuthenticatorsInfo:
    (accessToken, callback) =>
    async ({ Api }) => {
      const { result } = await Api.get(`authenticators/setup`, undefined, {
        Authorization: `Bearer ${accessToken}`,
      });
      if (result) {
        callback && callback(result);
      } else {
        callback && callback(false);
      }
    },
  validateAuthenticatorsCode:
    ({ accessToken, code }, callback) =>
    async ({ Api }) => {
      const { result } = await Api.post(
        `authenticators/validations`,
        { code },
        undefined,
        {
          Authorization: `Bearer ${accessToken}`,
        }
      );
      if (result) {
        callback && callback(result);
      } else {
        callback && callback(false);
      }
    },
  getUserPasscode:
    () =>
    async ({ Api }) => {
      const { result } = await Api.get(`passcodes`);
      if (result) {
        authDispatcher.setState('userPasscode', result);
      }
    },
  confirmPatientAcknowledgesResult:
    (params, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post('patients/acknowledge', params);
      if (status === 200 || status === 400) {
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    },
  acknowledgeNudgeAngelsEmail:
    (params, callback) =>
    async ({ Api }) => {
      const { status } = await Api.post(
        'NudgeAngels/email-acknowledge',
        params
      );
      if (status === 200 || status === 400) {
        callback && callback(true);
      } else {
        callback && callback(false);
      }
    },

  loginPatient:
    (email, password, callback) =>
    async ({ Api }) => {
      const body = {
        email,
        password,
        clientType: 'Mobile',
      };
      const { result, message, status } = await Api.post(
        `auth/sessions`,
        body,
        undefined,
        undefined,
        false
      );
      if (status === 200) {
        callback(result, email);
      } else {
        if (message === 'User does not exist')
          callback('Wrong username and password', null);
        else callback(message);
      }
    },

  registerPatient:
    (params, callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.post(`patients/register`, params);
      if (status === 200) {
        callback && callback(true, result);
      } else {
        callback && callback(false);
      }
    },
  sendResetPasswordEmailPatient:
    (email, callback) =>
    async ({ Api }) => {
      const { status, result } = await Api.post('users/password/forgot', {
        email,
        clientType: 'Mobile',
      });
      if (status === 200) {
        callback && callback(result);
      }
    },
  checkPatientPreregistersAccount:
    (params, onSuccess) =>
    async ({ Api }) => {
      const { status, result } = await Api.post(
        'patients/pre-register',
        params
      );
      if (status === 200) {
        onSuccess && onSuccess(result);
      }
    },

  sendEmailActive:
    (email, onSuccess, onFail) =>
    async ({ Api }) => {
      const { status, result, message } = await Api.post(
        'patients/account-activations',
        {
          email,
        },
        {},
        {},
        false
      );
      if (status === 200) {
        onSuccess && onSuccess(result);
      } else {
        onFail && onFail(message);
      }
    },

  addPatient:
    (params, onSuccess, onError) =>
    async ({ Api }) => {
      const { status, result } = await Api.post('users/patients', params);
      if (status === 200) {
        onSuccess && onSuccess(result);
      } else {
        onError && onError();
      }
    },

  // Singpass
  getSingpassLoginUrl:
    (redirectUrl, onSuccess, isLogin) =>
    async ({ Api }) => {
      const { result } = await Api.get('Auth/singpass-login-url', {
        redirectUrl,
        ...(isLogin && { isLogin: true }),
      });
      onSuccess && onSuccess(result);

      return result;
    },
  loginSingpass:
    (params, callback, callbackError) =>
    async ({ Api }) => {
      const { status, result } = await Api.post(
        'auth/sessions/singpass',
        params,
        null,
        null,
        false
      );
      if (status === 200) {
        callback && callback(result);
      } else {
        callbackError && callbackError();
      }
    },
  loginPatientWithGoogle:
    (token, callback, onFailed) =>
    async ({ Api }) => {
      const body = {
        role: 'Patient',
        clientType: 'Mobile',
        token,
      };
      const { result, status, message } = await Api.post(
        `auth/sessions/google`,
        body,
        {},
        {},
        false
      );
      if (status === 200) {
        callback(result);
      } else {
        onFailed && onFailed(message, status);
      }
    },
  loginPatientWithApple:
    (token, callback, onFailed) =>
    async ({ Api }) => {
      const body = {
        token,
      };
      const { result, status, message } = await Api.post(
        `auth/sessions/apple?isMinmedBooking=true`,
        body,
        {},
        {},
        false
      );
      if (status === 200) {
        callback(result);
      } else {
        onFailed && onFailed(message, status);
      }
    },
};

// Status BE returns from auth/sessions/google|apple when the social account
// has no MinC user yet — FE then sends the user to Patient Register.
export const SOCIAL_NOT_REGISTERED_STATUS = 404;

const authDispatcher = synthesize('auth', mapDispatchToAC);
export default authDispatcher;
